import React, { Component } from 'react'
import {
    PRODUCTIVITY_PROJECTS_UPDATE_URL, EXCEL_TEMPLATE_FOLDER_PATH,FTE_EXCEL_TEMPLATE_LINK, GET_METADATA,
    DATA_BRIDGE_CAMPAIGN, X_POLLINATION_CAMPAIGN, ACCESS_TOKEN, USER_DATA, PRODUCTIVITY_PROJECTS_DETAILS_URL,
    PRODUCTIVITY_CLIENT_APPLICABLE, REDUCTION_TO_OVER_DEPLOYMENT_BENCH, PRODUCTIVITY_GENPACT_APPLICABLE_RGFTE,
    NO_VD, VD_TO_CLIENT, VD_TO_GENPACT, VD_TO_CLIENT_PLUS_GENPACT, IMPACT_TO_CLIENT, IMPACT_TO_GENPACT, PRODUCTIVITY,AGED_BENCH_REDUCTION,AWAITING_MASTER_BLACKBELT_APPROVAL,DOCUMENTS_UPLOADED,PENDING_DOCUMENTS,COMPLETE_STATUS,AWAITING_QAULITY_CHECK_REVIEW
} from '../assets/constants/constants';
import Toast from 'light-toast';
import * as XLSX from 'xlsx';
import Select from "react-select";
import ProductivityUIGrid from '../utils/ProductivityUIGrid';
import ProductivityUIGridFTE from '../utils/ProductivityUIGridFTE'

export class ProductivityDetailsPage extends Component {
    sessionData = JSON.parse(localStorage.getItem(USER_DATA));
    accessToken = localStorage.getItem(ACCESS_TOKEN); 
    constructor(props) {
        super(props)
        let propsData = this.props.location;
        // console.log('props receieved =>',propsData)

        this.MAX_ROWS = 10;

        this.state = {
            campaignName: "",
            serviceLineName: "",
            dataBridgeCampaign: false,
            xPollinationCampaign: false,
            propsData: propsData,

            Role: "",
            businessImpactValueArray: [],
            summaryArray: [],
            qcCommentLog: false,
            qcComments: [],

            duplicateQCOHR: "",
            SubCampaignName: "",
            qcCommentsWithVD: [],
            qcLastComment: "",


            // productivity
            methodologies: "",
            methodologyList: [],
            totalOHRUploaded: 0,

            productivityPopUp: false,
            ApprovalStatus: "",
            WorkflowStatus: "",
            AccountManual: "",
            RegionManual: "",
            IdeaId: "",
            LeanId: "",
            IdeaIDAlpha: "",
            OwnerOHR: "",

            prodBiSrNo: "",
            prodBiImpact: "",
            prodBiMonetizableType: "",
            prodBiType: "",
            prodBIFTEImpact: "",

            gridData: {},
            producitivityTotalFTE: 0.0,

            CertificationLevelName: "",
            TransformationLeverName: "",

            projectDetails: {},

            HoldingAccount: "",
            VerticalManual: "",
            SubVerticalName: "",
            Segment: "",
            Unit: "",
            CampaignName: "",
            DataBridgeTheme: "",
            isAI: "",
            Country: "",

            SubRegion: "",
            BlackBeltUserName: "",
            BlackBeltUserId: "",
            MBBName: "",
            MBBOHR: "",

            ProjectID: "",
            ServiceLineName: "",
            SubServiceLine: "",
            ProjectName: "",
            Problem: "",
            Solution: "",
            LDT: "",
            LDTOHR: "",
            Certificate: "",
            TransformationLever: "",
            DigitalProjectType: "",
            AIClassification: "",
            WorkType: "",
            ToolsMethodologies: "",
            OtherTools: "",
            VDType: "",

            ProjectPhase: "",
            ProjectState: "",

            isItIdeaOrGB: "",

            projectName: "",

            dataForUploadedScreen: {},

            backFillPopup:false,

            fteCategories:[]
            
        }
    }


    async componentDidMount() {
        await this.fetchMetadata();
        await this.fetchProjectDetails();
    }

    fetchMetadata = async () => {
        try {
            const param = {
                EntityType: "",
                EntityName: "",
            };
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param),
            };

            const response = await fetch(GET_METADATA, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    Toast.hide();
                    this.setState({ 
                        businessImpactMasterList: data ? data.BIMasterDataVerseNew : [], 
                    }, () => { 

                        let fteCategories = this.state.businessImpactMasterList?.filter((item)=>{return item.pg_isohruploaded === "FTE"})
                        this.setState({fteCategories:fteCategories},()=>{})
                    });
                }
            }
        } catch (error) {
            console.log(error)
            Toast.fail("Error occured while getting metadata idea. Please try again!", 3000, () => { });
        }
    };

    fetchProjectDetails = async () => {
        try {
            Toast.loading("Fetching project details. Please wait...", () => { });
            if (this.state.propsData.state[0]) {
                let projectIDForQuery = null;
                if (this.state.propsData.state[0].startsWith("I-") || this.state.propsData.state[0].startsWith("L-")) {
                    projectIDForQuery = this.props.location.state[1]
                    this.setState({ isItIdeaOrGB: "Lean" }, () => { })
                } else {
                    projectIDForQuery = this.props.location.state[0]
                    this.setState({ isItIdeaOrGB: "GB" }, () => { })
                }
                const requestOptions = {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: 'Bearer ' + this.accessToken
                    },
                };
                const response = await fetch(`${PRODUCTIVITY_PROJECTS_DETAILS_URL}projectID=${projectIDForQuery}&isItIdeaOrGB=${this.state.isItIdeaOrGB}&IdeaID=${this.props.location.state[1]}`, requestOptions)
                if (response.ok) {
                    const data = await response.json();
                    Toast.hide()
                    if (data) {
                        Toast.hide()
                        if (this.state.isItIdeaOrGB === 'Lean') {
                            this.setLeanDetails(data)
                            Toast.hide()
                        }
                        if (this.state.isItIdeaOrGB === 'GB') {
                            this.setGBDetails(data)
                            Toast.hide()
                        }
                    }
                } else {
                    Toast.hide()
                    Toast.fail("Error while fetching project details. Please try again!", 3000, () => { });
                }
            }
        }
        catch (error) {
            Toast.hide()
            console.log(error)
            Toast.fail("Error while fetching project details. Please try again!", 3000, () => { });
        };
    }

    setLeanDetails = (data) => {
        console.log("lean function called")
        if (data) {
            this.setState({
                projectDetails: data.ProjectDetails ? data.ProjectDetails[0] ? data.ProjectDetails[0] : {} : {},
                businessImpactValueArray: data.BIData ? data.BIData : [],
            }, () => {

                if (data.ProductivityTableData) {
                    this.setProductivityDetails(data.ProductivityTableData)
                }

                if (this.state.businessImpactValueArray && this.state.businessImpactValueArray.length > 0) {
                    this.newBusinessImpactSummary()
                }
                if (this.state.projectDetails) {
                    this.setState({
                        WorkflowStatus: this.state.projectDetails.WorkflowStatus ? this.state.projectDetails.WorkflowStatus : "",
                        dataBridgeCampaign: (this.state.projectDetails.CampaignName === DATA_BRIDGE_CAMPAIGN),
                        xPollinationCampaign: (this.state.projectDetails.CampaignName === X_POLLINATION_CAMPAIGN),
                        SubCampaignName: this.state.projectDetails.SubCampaignName ? this.state.projectDetails.SubCampaignName : "",
                        ApprovalStatus: this.state.projectDetails.ApprovalStatus ? this.state.projectDetails.ApprovalStatus : "",
                        OwnerOHR: this.state.projectDetails.OwnerOHR ? this.state.projectDetails.OwnerOHR : "",
                        BlackBeltUserId: this.state.projectDetails.BlackBeltUserId ? this.state.projectDetails.BlackBeltUserId : "",
                        OwnerName: this.state.projectDetails.OwnerName,
                        AccountManual: this.state.projectDetails.AccountManual,
                        HoldingAccount: this.state.projectDetails.HoldingAccount,
                        VerticalManual: this.state.projectDetails.VerticalManual,
                        SubVerticalName: this.state.projectDetails.SubVerticalName,
                        Segment: this.state.projectDetails.Segment,
                        Unit: this.state.projectDetails.Unit,
                        CampaignName: this.state.projectDetails.CampaignName,
                        DataBridgeTheme: this.state.projectDetails.DataBridgeTheme,
                        isAI: this.state.projectDetails.isAI,
                        LDTLeadName: this.state.projectDetails.LDTLeadName,
                        Country: this.state.projectDetails.Country,
                        RegionManual: this.state.projectDetails.RegionManual,
                        SubRegion: this.state.projectDetails.SubRegion,
                        BlackBeltUserName: this.state.projectDetails.BlackBeltUserName,
                        MBBName: this.state.projectDetails.MBBName,

                        ServiceLineName: this.state.projectDetails.ServiceLineName,
                        SubServiceLine: this.state.projectDetails.SubServiceLine,
                        ProjectName: this.state.projectDetails.IdeaName,
                        Problem: this.state.projectDetails.Problem,
                        Solution: this.state.projectDetails.Solution,

                        Certificate: this.state.projectDetails.CertificationLevelName,
                        TransformationLever: this.state.projectDetails.TransformationLeverName,
                        DigitalProjectType: this.state.projectDetails.DigitalProjectType,
                        AIClassification: this.state.projectDetails.AIClassification,
                        WorkType: this.state.projectDetails.CertificationWorkTypeName,
                        OtherTools: this.state.projectDetails.OtherTools,

                        VDType: this.state.projectDetails.VDType,
                        FinalImpactFTE: this.state.projectDetails.FinalImpactFTE,
                        FinalImpactDollar: this.state.projectDetails.FinalImpactDollar,

                        IdeaId: this.state.projectDetails.IdeaId,
                        LeanID: this.state.projectDetails.LeanID,
                        IdeaIDAlpha: this.state.projectDetails.IdeaIDAlpha,
                        projectName: this.state.projectDetails.IdeaName
                    }, () => {
                    })

                    if (this.state.projectDetails.MethodologyName) {
                        let localMethodologies = this.state.projectDetails.MethodologyName.replace(/[|,]/g, ", ")
                        localMethodologies = localMethodologies.split(",").join(", ");
                        this.setState({ ToolsMethodologies: localMethodologies }, () => { })
                    }



                    if (this.state.projectDetails.VDType === NO_VD) {
                        this.setState({
                            showClientFields: false, showGOLFields: false, IsVDMonetizable: false, MonetizationStatus: "",
                            summaryArray: "", businessImpactValueArray: "", duplicateQCOHR: ""
                        }, () => { })
                    }
                    Toast.hide()
                }


            })
        }
    }

    setGBDetails = (data) => {
        console.log("GB function called +>")
        if (data) {
            this.setState({
                projectDetails: data.ProjectDetails ? data.ProjectDetails[0] ? data.ProjectDetails[0] : {} : {},
                businessImpactValueArray: data.BIData ? data.BIData : []
            }, () => {
                if (data.ProductivityTableData) { this.setProductivityDetails(data.ProductivityTableData) }

                
                if (this.state.businessImpactValueArray && this.state.businessImpactValueArray.length > 0) {
                    this.newBusinessImpactSummary()

                    let containsOnlyClient = this.state.businessImpactValueArray.some(item => item.pg_impacttype === IMPACT_TO_CLIENT);
                    let containsOnlyGenpact = this.state.businessImpactValueArray.some(item => item.pg_impacttype === IMPACT_TO_GENPACT);
                    let containsBoth = this.state.businessImpactValueArray.some(item => item.pg_impacttype === IMPACT_TO_CLIENT && item.pg_impacttype === IMPACT_TO_GENPACT);


                    if (containsOnlyClient) {
                        this.setState({ VDType: VD_TO_CLIENT }, () => { })
                    }
                    else if (containsOnlyGenpact) {
                        this.setState({ VDType: VD_TO_GENPACT }, () => { })
                    }
                    else if (containsBoth) {
                        this.setState({ VDType: VD_TO_CLIENT_PLUS_GENPACT }, () => { })
                    } else {
                        this.setState({ VDType: NO_VD }, () => { })
                    }
                    if (this.state.projectDetails.pg_bitotal) {
                        if (this.state.projectDetails.pg_bitotal === "0 Impact Project") {
                            this.setState({ VDType: NO_VD })
                        }
                    }
                }
            })
            if (this.state.projectDetails) {
                this.setState({
                    OwnerOHR: this.state.projectDetails.pg_projownerohr,
                    BlackBeltUserId: this.state.projectDetails.pg_mentorohr,
                    OwnerName: this.state.projectDetails.pg_projowner,
                    AccountManual: this.state.projectDetails.pg_account,
                    HoldingAccount: this.state.projectDetails.pg_holdingaccount,
                    VerticalManual: this.state.projectDetails.pg_vertical,
                    SubVerticalName: this.state.projectDetails.pg_subvertical,
                    Segment: this.state.projectDetails.pg_segment,
                    Unit: this.state.projectDetails.pg_unit,
                    CampaignName: this.state.projectDetails.pg_campaignname,
                    LDTLeadName: this.state.projectDetails.pg_ldtlead,
                    Country: this.state.projectDetails.pg_country,
                    RegionManual: this.state.projectDetails.pg_region,
                    SubRegion: this.state.projectDetails.pg_subregion,
                    BlackBeltUserName: this.state.projectDetails.pg_mentor,
                    // MBBName:this.state.projectDetails.,
                    ServiceLineName: this.state.projectDetails.pg_serviceline1txt,
                    SubServiceLine: this.state.projectDetails.pg_serviceline2txt,
                    ProjectName: this.state.projectDetails.msdyn_subject,
                    Problem: this.state.projectDetails.pg_problemstmt,
                    Solution: this.state.projectDetails.pg_solution,

                    TransformationLever: this.state.projectDetails.pg_transformationlever || this.state.projectDetails.pg_natureofprojectcalculated,
                    DigitalProjectType: this.state.projectDetails.pg_digitalprojecttype,
                    WorkType: this.state.projectDetails.pg_worktypetxt,
                    OtherTools: this.state.projectDetails.pg_othertools,
                    // VDType:this.state.projectDetails.pg_bitotal,
                    // FinalImpactFTE:this.state.projectDetails.,
                    // FinalImpactDollar:this.state.projectDetails.,
                    ProjectState: this.state.projectDetails.pg_projectstate,
                    ProjectPhase: this.state.projectDetails.pg_statuscode,
                    AIClassification: this.state.projectDetails.pg_aiclassification,

                    projectName: this.state.projectDetails.msdyn_subject
                }, () => {
                    if (this.state.projectDetails.pg_methodology) {
                        let localMethodologies = this.state.projectDetails.pg_methodology.replace(/[|,]/g, ", ")
                        localMethodologies = localMethodologies.split(",").join(", ");
                        this.setState({ ToolsMethodologies: localMethodologies }, () => { })
                    }

                    let GBProject = ["GB-ProDG", "GB-BPMS Live"]
                    let GBPlusProject = ["POV Deploy", "POV Design", "ProDG-4D", "Ops Initiatives", "BPMS Live"]

                    if (this.state.projectDetails.pg_txtfield_2 && this.state.projectDetails.pg_txtfield_2 === "GB") {
                        this.setState({ Certificate: "GB" }, () => { })
                    } else {
                        this.setState({ Certificate: "Lean" }, () => { })
                    }

                    if (GBProject.includes(this.state.projectDetails.pg_worktypetxt)) {
                        this.setState({ Certificate: "GB" }, () => { })
                    }

                    if (GBPlusProject.includes(this.state.projectDetails.pg_worktypetxt)) {
                        this.setState({ Certificate: "GB" }, () => { })
                    }
                })
            }
            Toast.hide()
        }
    }

    setProductivityDetails = (ProductivityTableData) => {
        if (!Array.isArray(ProductivityTableData)) return;

        this.setState(prevState => {
            const updatedGridData = { ...prevState.gridData };

            // Group rows by BISrNo
            const grouped = {};
            ProductivityTableData.forEach(row => {
                const biSrNo = row.BISrNo || row.SrNo || row.Column2;
                if (biSrNo) {
                    if (!grouped[biSrNo]) {
                        grouped[biSrNo] = [];
                    }
                    grouped[biSrNo].push(row);
                }
            });

            // Replace old entries with the new ones (instead of merging)
            Object.keys(grouped).forEach(biSrNo => {
                updatedGridData[biSrNo] = grouped[biSrNo];
            });

            return { gridData: updatedGridData };
        });
    };


    updateProjectBI = (businessImpactItem, SrNo) => {
        Toast.loading("Updating the productivity details. Please wait...", () => { });
        let param = {};

        console.log('business impact item receieved =>',businessImpactItem)
        param = {
            casetype: "UpdateFlag",
            isItIdeaorGB: this.state.isItIdeaOrGB ? this.state.isItIdeaOrGB : "",
            ideaId: this.props.location.state[1] ? this.props.location.state[1] : "",
            ProjectID: this.props.location.state[0] ? this.props.location.state[0] : "",

            businessImpactValueArray: businessImpactItem,

            UpdaterOHR: this.sessionData.profile.oHRId,
            UpdaterName: this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
            UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",

            ApprovalStatus: this.state.ApprovalStatus,
            ProjectPhase: this.state.ProjectState,
            ProjectState: this.state.ProjectPhase,
        }

        console.log("param =>", param)

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + this.accessToken,
            },
            body: JSON.stringify(param)
        };
        fetch(`${PRODUCTIVITY_PROJECTS_UPDATE_URL}`, requestOptions)
            .then(response => response.json())
            .then(data => {
                console.log(data)
                Toast.hide();
                if (data && data.Message === "Productive OHR count and Productivity flag set succesfully") {
                    Toast.success("OHR's are released successfully.", 5000, () => {
                        this.sendEmail(SrNo, this.state.prodBiImpact, this.state.prodBiType)
                    });

                }
            }).catch = (err) => {
                console.log("error =>", JSON.stringify(err))
                Toast.hide()
                Toast.fail("There is a failure in data saving OHRs count and productivity flag. Please try again.", 10000, () => { })
                return;
            }
    }


    FTEProjectBIUpdate = (businessImpactItem, SrNo) => {
        Toast.loading("Updating the productivity details. Please wait...", () => { });
        let param = {};

        console.log('business impact item receieved =>',businessImpactItem)
        param = {
            casetype: "UpdateFTEOHRCount",
            isItIdeaorGB: this.state.isItIdeaOrGB ? this.state.isItIdeaOrGB : "",
            ideaId: this.props.location.state[1] ? this.props.location.state[1] : "",
            ProjectID: this.props.location.state[0] ? this.props.location.state[0] : "",

            businessImpactValueArray: businessImpactItem,

            UpdaterOHR: this.sessionData.profile.oHRId,
            UpdaterName: this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
            UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",

            ApprovalStatus: this.state.ApprovalStatus,
            ProjectPhase: this.state.ProjectState,
            ProjectState: this.state.ProjectPhase,
        }

        console.log("param =>", param)

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + this.accessToken,
            },
            body: JSON.stringify(param)
        };
        fetch(`${PRODUCTIVITY_PROJECTS_UPDATE_URL}`, requestOptions)
            .then(response => response.json())
            .then(data => {
                console.log(data)
                Toast.hide();
                if (data && data.Message === "FTEs OHR count and Productivity flag set succesfully") {
                    Toast.success("OHR's are released successfully.", 5000, () => {
                        this.sendEmail(SrNo, this.state.prodBiImpact, this.state.prodBiType)
                    });

                }
            }).catch = (err) => {
                console.log("error =>", JSON.stringify(err))
                Toast.hide()
                Toast.fail("There is a failure in data saving OHRs count and productivity flag. Please try again.", 10000, () => { })
                return;
            }
    }

    sendEmail = (SrNo, impactType, bicategory) => {
        return new Promise((resolve, reject) => {
            Toast.loading("Sending you email for GOL and FP&A approval documents. Please Wait....", () => { });
            let param = {};
            param = {
                casetype: "sendEmail",
                LeanID: this.state.LeanID,
                projectIDForFetch: this.state.isItIdeaOrGB === "Lean" ? this.props.location.state[1] : this.props.location.state[0],
                projectIDToDisplay: this.state.isItIdeaOrGB === "Lean" ? this.state.LeanID : this.props.location.state[0],

                IdeaID: this.props.location.state[1],
                UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                projectName: this.state.projectName,
                Account: this.state.AccountManual,
                Region: this.state.RegionManual,
                Vertical: this.state.VerticalManual,
                Owner: this.state.OwnerName,
                Mentor: this.state.BlackBeltUserName,
                MentorID:this.state.BlackBeltUserId+ "@genpact.com",
                OwnerOHR:this.state.OwnerOHR + "@genpact.com",

                isFTECategory:this.state.fteCategories.some((item)=> item.pg_srno === SrNo),
                SrNo: SrNo,
                impactType: impactType,
                bicategory: bicategory,

            }

            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param)
            };
            fetch(`${PRODUCTIVITY_PROJECTS_UPDATE_URL}`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    resolve();
                    Toast.hide();
                    console.log(data.Message)
                    Toast.hide();
                    if (data && data.Message === "Email sent succesfully") {
                        Toast.hide()
                        Toast.success("Email requesting GOL and FP&A approval documents sent to you successfully.", 5000, () => { });
                        Toast.hide()
                    }
                }).catch = (err) => {
                    Toast.hide()
                    console.log("error =>", JSON.stringify(err))
                    Toast.fail("There is a failure in sending email requesting GOL and FP&A approval documents.", 5000, () => { })
                    return;
                }
        })

    }

    cancelEvent = () => {
        if (this.props.location.state && this.props.location.state[2]) {
            if (this.props.location.state[2] === "MentorPage") {
                this.props.history.push({
                    pathname: "/productivity-mentor-list-page",
                });
            }
            if (this.props.location.state[2] === "OwnerPage") {
                this.props.history.push({
                    pathname: "/productivity-owner-list-page",
                });
            }
        }
    }

    newBusinessImpactSummary() {
        console.log("bi data => ", this.state.businessImpactValueArray)
        if (this.state.businessImpactValueArray) {
            const keyMapping = {
                "pg_srno": "SrNo",
                "pg_impacttype": "ImpactType",
                "pg_monetizabletype": "MonetizableType",
                "pg_bisubcategory": "BISubCategory",
                "pg_fteimpactvalue": "FTEImpact",
                "pg_impactvalue": "DollarImpact",
                "pg_isfteimpact": "isFTEPresent",
                "pg_ismonetized": "IsMonetized",
                "pg_ohrpastcount": "OHRPastCount",
                "pg_ohrfuturecount": "OHRFutureCount",
                "pg_pvalid": "PValid",
                "pg_ohrexceptioncount":"OHRExceptionCount",
                "pg_ohrvalidcount":"OHRValidCount",
                "pg_ohrsumfte":"OHRSumFTE",
                
            };

            const updatedDef = this.state.businessImpactValueArray && this.state.businessImpactValueArray.map(item => {
                const newItem = {};
                for (const key in item) {
                    if (keyMapping[key]) {
                        newItem[keyMapping[key]] = item[key];
                    } else {
                        newItem[key] = item[key]; // preserve if not mapped
                    }
                }
                return newItem;
            });

            let dollarTotal = 0.0;
            let fteValue = 0.0;

            this.state.businessImpactValueArray && this.state.businessImpactValueArray.map((item) => {
                if (item && item.DollarImpact) {
                    dollarTotal += parseFloat(item.DollarImpact);
                }
                if (item && item.FTEImpact) {
                    fteValue += parseFloat(item.FTEImpact);
                }
            })

            this.setState({
                businessImpactValueArray: updatedDef,
                FinalImpactFTE: fteValue,
                FinalImpactDollar: dollarTotal,

                dataForUploadedScreen: updatedDef.reduce((acc, item) => {
                    acc[item.SrNo] = {
                        OHRPastCount: item.OHRPastCount ? item.OHRPastCount : 0,
                        OHRFutureCount: item.OHRFutureCount ? item.OHRFutureCount : 0,
                        OHRExceptionCount:item.OHRExceptionCount ? item.OHRExceptionCount : 0,
                        OHRValidCount:item.OHRValidCount ? item.OHRValidCount : 0,
                        OHRSumFTE:item.OHRSumFTE ? item.OHRSumFTE:0
                    };
                    return acc;
                }, {})

            }, () => {
                console.log("business impact value array from new business impact summary function =>", this.state.businessImpactValueArray)
            })
        }
    }

    // productivity function starts here
    productivitySampleFileDownload = (e,SrNo) => {
        let isFTECategory = this.checkIsFteEquivalentPresent(SrNo)
        const fileUrl = isFTECategory ? FTE_EXCEL_TEMPLATE_LINK : EXCEL_TEMPLATE_FOLDER_PATH;
        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = "ProductivityTemplate.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    exportProductivityData = (e, SrNo) => {
        let ReleaseType = "";
        console.log('grid data =>',this.state.gridData && this.state.gridData[SrNo])
        let data = this.state.gridData && this.state.gridData[SrNo];

        if (SrNo === 121 || SrNo === "121" || SrNo === 122 || SrNo === "122") {
            ReleaseType = "RGFTE"
        }
        if (SrNo === 120 || SrNo === "120" || SrNo === 123 || SrNo === "123") {
            ReleaseType = "Bench"
        }

        // let projectID = this.props.location.state[3] ? this.props.location.state[3] : "";
        let projectID = this.state.isItIdeaOrGB === "Lean" ? this.props.location.state[3] : this.state.isItIdeaOrGB === "GB" ? this.props.location.state[0] : ""
        let AccountName = "";
        AccountName = data && data[0].Account;

        console.log(data)

        const formattedData = data && data.map((item, index) => ({
            Message: item.Msg ? item.Msg : "Successful",
            "Release Category":item.Catg,
            "Release Description":item.Descr,
            "OHR ID": item.OHR,
            "Release Date": item.ReleaseDate ? this.formatDateString(new Date(item.ReleaseDate)) : "-",
            "Released From PID": item.PID,
            "Name": item.OHRName ? item.OHRName : "-",
            Account: item.Account,
            Region: item.Region,
            "Release Type": item.ReleaseType,
            "Cost Code": item.ReleaseCode,
            Billability: item.Billability,
            "Comment":item.Comment,
            "Headcount Release Levers":item.HCLever,
            "Capability":item.Capability,
            "Productivity Type":item.Pvity

        }));

        if (formattedData) {
            // Create worksheet from data
            const worksheet = XLSX.utils.json_to_sheet(formattedData, { origin: "A1" });

            const messageCellAddress = 'Q2';
            worksheet[messageCellAddress] = {
                t: 's',
                v: "To update or add data, make sure your file matches the format in the sample file",
            };

            const messageColumnIndex = 16;
            const messageWidth = 80;

            // Update worksheet range to include column D
            const originalRange = XLSX.utils.decode_range(worksheet['!ref']);
            originalRange.e.c = Math.max(originalRange.e.c, 16);
            worksheet['!ref'] = XLSX.utils.encode_range(originalRange);

            const headers = Object.keys(formattedData[0]);
            const colWidths = headers.map((header, colIndex) => {
                let maxLength = header.length;

                for (let rowIndex = 0; rowIndex < formattedData.length; rowIndex++) {
                    const cellValue = formattedData[rowIndex][header];
                    if (cellValue !== undefined && cellValue !== null) {
                        const cellLength = cellValue.toString().length;
                        maxLength = Math.max(maxLength, cellLength);
                    }
                }

                return { wch: maxLength + 2 };
            });
            worksheet['!cols'] = colWidths;
            worksheet['!cols'][messageColumnIndex] = { wch: messageWidth };

            // Add autofilter
            worksheet['!autofilter'] = { ref: XLSX.utils.encode_range(originalRange) };
            // Create and write workbook
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, `Productivity - ${AccountName} - ${projectID} - ${ReleaseType}.xlsx`);
        }
    }



    FTEExportData = (e, SrNo) => {
        let data = this.state.gridData && this.state.gridData[SrNo];

        let projectID = this.state.isItIdeaOrGB === "Lean" ? this.props.location.state[3] : this.state.isItIdeaOrGB === "GB" ? this.props.location.state[0] : ""
        let AccountName = "";
        AccountName = data && data[0].Account;

        // console.log('export data =>',data)

        const FTEFormatedDate = data && data.map((item, index) => ({
            Message: item.Msg ? item.Msg : "Successful",
            "Active OHR ID": item.OHR,
            "Employee Name": item.OHRName ? item.OHRName : "-",
            "Realization Date": item.ReleaseDate ? this.formatDateString(new Date(item.ReleaseDate)) : "-",
            Account: item.Account,
            Region: item.Region,
            "Realised to PID": item.PID,
            "Realised FTE Impact":item.OHRFTE ? item.OHRFTE : item.FTE ? item.FTE : "-",
            "Release Type": item.ReleaseType,
            "Headcount Release Levers":item.HCLever,
            "Productivity Type":item.Pvity,
            "Capability":item.Capability
        }));

        // Create worksheet from data
        const worksheet = XLSX.utils.json_to_sheet(FTEFormatedDate, { origin: "A1" });

        const messageCellAddress = 'M2';
        worksheet[messageCellAddress] = {
            t: 's',
            v: "To update or add data, make sure your file matches the format in the sample file",
        };

        const messageColumnIndex = 12;
        const messageWidth = 80;

        // Update worksheet range to include column D
        const originalRange = XLSX.utils.decode_range(worksheet['!ref']);
        originalRange.e.c = Math.max(originalRange.e.c, 12);
        worksheet['!ref'] = XLSX.utils.encode_range(originalRange);

        const headers = Object.keys(FTEFormatedDate[0]);
        const colWidths = headers.map((header, colIndex) => {
            let maxLength = header.length;

            for (let rowIndex = 0; rowIndex < FTEFormatedDate.length; rowIndex++) {
                const cellValue = FTEFormatedDate[rowIndex][header];
                if (cellValue !== undefined && cellValue !== null) {
                    const cellLength = cellValue.toString().length;
                    maxLength = Math.max(maxLength, cellLength);
                }
            }

            return { wch: maxLength + 2 };
        });
        worksheet['!cols'] = colWidths;
        worksheet['!cols'][messageColumnIndex] = { wch: messageWidth };

        // Add autofilter
        worksheet['!autofilter'] = { ref: XLSX.utils.encode_range(originalRange) };
        // Create and write workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, `Productivity - ${AccountName} - ${projectID}.xlsx`);
    }







    openProductivityPopUp = (index, item) => {
        let confirmationMessage = `GOL and FP&A approvals are mandatory for all productivity claims. I confirm that these approvals will be shared with the Central Audit Team at LDT.DNC@Genpact.com after successful upload or claim of the productivity.`
        if (window.confirm(confirmationMessage)) {
            let localFTEImpact = parseInt(item.FTEImpact);
            this.setState({
                prodBiSrNo: item.SrNo,
                prodBiImpact: item.ImpactType,
                prodBiMonetizableType: item.MonetizableType,
                prodBiType: item.BISubCategory,
                productivityPopUp: true,
                prodBIFTEImpact: localFTEImpact
            }, () => { })
        }
    }

    closeProductivityPopup = (e) => {
        this.setState({
            productivityPopUp: false,
            prodBiSrNo: "",
            prodBiImpact: "",
            prodBiMonetizableType: "",
            prodBiType: "",
        }, () => {
            //window.location.reload();
        })
    }

    



    excelDateToJSDate(serial) {
        if (typeof serial === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(serial)) {
            return serial;
        }
        // this function converts the Excel sheet numeric date format to ISO string
        const utcDays = serial - 25569; // 25569 is the number of days between 1900-01-01 and 1970-01-01
        const milliseconds = utcDays * 86400000; // 86400000 is the number of milliseconds in a day
        return new Date(milliseconds).toLocaleDateString('en-CA');
    }


    handleUploadProceedClick=(e)=>{
        // 1. Trigger click on the PERMANENT input
        document.getElementById('productivityFileUpload').click();
        // 2. Close popup
        this.setState({ backFillPopup: false });
    }

    uploadFile = (event, prodBIFTEImpact, prodBiSrNo) => {
        
        let confirmationMessage = '';
        let filteredData = null;

        filteredData = this.state.gridData && this.state.gridData[prodBiSrNo]
        if (filteredData && filteredData.length > 0) {
            confirmationMessage = "Heads up: Uploading this file will replace any previous data for this ID. If a release isn't in the new file, it will be removed and can't be restored later";
        } else {
            confirmationMessage = "Are you sure you want to upload this excel template ?"
        }

        let userOhr = this.sessionData ? this.sessionData.profile ? this.sessionData.profile.oHRId : "" : "";
        if (parseInt(this.state.OwnerOHR) === parseInt(userOhr) || parseInt(this.state.BlackBeltUserId) === parseInt(userOhr)) {
            var file = event.target.files[0];
            var currFilename = file ? file.name : "";
            var validExtensions = ['.xlsx'];
            var currFileExtension = currFilename.substring(currFilename.lastIndexOf("."));
            var isFileTypeValid = validExtensions.filter((val) => val.toLowerCase().includes(currFileExtension.toLowerCase()));
            if (isFileTypeValid.length <= 0) {
                alert("Only excel file is allowed to Upload.");
                return;
            } else {
                if (window.confirm(confirmationMessage)) {
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(event.target.files[0]);
                    reader.onload = (e) => {
                        console.log("e =>", e)
                        const data = e.target.result;
                        const workbook = XLSX.read(data, { type: 'binary',sheetStubs: true});
                        const sheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[sheetName];

                        const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];

                        const hasHeadCountColumn = headers && headers.includes("Headcount Release Levers");

                        if (!hasHeadCountColumn) {
                            Toast.fail("Column 'Headcount Release Levers' is missing. Make sure that the column is present.", 4000);
                            event.target.value = null;
                            return false;
                        }

                        // Set raw: false to get formatted values
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false });
                        const lengthOfRows = jsonData.length;

                        if (lengthOfRows === 0) {
                            Toast.fail("Please insert the records and upload.", 4000, () => { })
                            event.preventDefault()
                            event.target.value = null;
                            return false;
                        }
                        if (lengthOfRows + parseInt(1) > 201) {
                            Toast.fail("Data uploaded in excel is more than 200 rows.", 8000, () => { })
                            event.preventDefault()
                            event.target.value = null;
                            return false;
                        }
                        else {
                            let isValid = true;
                            const processedData = jsonData && jsonData;
                            if (processedData) {
                                const invalidRows = processedData.filter((row, index) => {
                                    const dateVal = row['Release Date'];
                                    // Accept yyyy-mm-dd or yyyy/mm/dd, then normalize
                                    if (typeof dateVal === 'string' && /^\d{4}[-\/]\d{2}[-\/]\d{2}$/.test(dateVal)) {
                                        const normalizedDate = dateVal.replace(/\//g, '-');
                                        // Optional: validate if it's a real date
                                        const dateObj = new Date(normalizedDate);
                                        return isNaN(dateObj.getTime()); // Invalid date object
                                    }
                                    return true; // Invalid format
                                });
                                if (invalidRows.length > 0) {
                                    //window.alert(`Invalid release date format in ${invalidRows.length} rows. Expected release date format is - 'yyyy-mm-dd'`);
                                    isValid = false;
                                }
                            }
                            
                            console.log('processed data =>',processedData)

                            if (isValid) {
                                Toast.loading("validating data please wait...", () => { });
                                let param = {
                                    case: "new",
                                    casetype: "validateProductiveOHR",
                                    excelParsedData: processedData,
                                    Account: this.state.AccountManual,
                                    BISrNo: this.state.prodBiSrNo,
                                    ProjectID: this.state.isItIdeaOrGB === "Lean" ? this.props.location.state[1] : this.state.isItIdeaOrGB === "GB" ? this.props.location.state[0] : "",
                                    Region: this.state.RegionManual,
                                    IdeaId: this.state.IdeaId ? this.state.IdeaId : "",
                                    CreateBy: this.sessionData ? this.sessionData.profile ? this.sessionData.profile.oHRId : "" : "",
                                }

                                console.log("param =>", param)
                                const requestOptions = {
                                    method: 'PUT',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        "Authorization": "Bearer " + this.accessToken,
                                    },
                                    body: JSON.stringify(param)
                                };
                                fetch(`${PRODUCTIVITY_PROJECTS_UPDATE_URL}`, requestOptions)
                                    .then(response => response.json())
                                    .then(data => {
                                        console.log("excel response =>", data)
                                        event.preventDefault()
                                        if (data) {
                                            event.target.value = null;
                                            const localData = data.ResultSets.Table1;
                                            this.setProductivityDetails(localData);

                                            let PastCount = data.ResultSets.Table2[0].PastCount;
                                            let FutureCount = data.ResultSets.Table2[0].FutureCount;
                                            let ExceptionCount = data.ResultSets.Table2[0].ExceptionCount;
                                            let ValidCount = data.ResultSets.Table2[0].ValidCount;

                                            if (data.ResultSets.Table2[0].RecStatus === "Success") {

                                                this.setState(prevState => ({
                                                    businessImpactValueArray: prevState.businessImpactValueArray.map(item =>
                                                        item.SrNo === this.state.prodBiSrNo
                                                            ? { ...item, OHRPastCount: PastCount, OHRFutureCount: FutureCount, PValid: "Yes", OHRValidCount: ValidCount, OHRExceptionCount: ExceptionCount }
                                                            : item
                                                    ),
                                                    dataForUploadedScreen: {
                                                        ...prevState.dataForUploadedScreen,
                                                        [this.state.prodBiSrNo]: { OHRPastCount: PastCount, OHRFutureCount: FutureCount, OHRExceptionCount: ExceptionCount, OHRValidCount: ValidCount }
                                                    }
                                                }));
                                                this.updateProjectBI(this.state.businessImpactValueArray, this.state.prodBiSrNo)
                                            }
                                            if (data.ResultSets.Table2[0].RecStatus === "Error") {

                                                this.setState(prevState => ({
                                                    dataForUploadedScreen: {
                                                        ...prevState.dataForUploadedScreen,
                                                        [this.state.prodBiSrNo]: { OHRPastCount: 0, OHRFutureCount: 0, OHRExceptionCount: 0, OHRValidCount: 0 }
                                                    }
                                                }));

                                                let failureMessage = 'Release for one or more OHRs does not qualify as valid release and hence the file cannot be uploaded. \n Please refer to the description below and make changes accordingly.';

                                                Toast.info(failureMessage, 10000, () => {
                                                    window.alert("Data not recorded.")
                                                });
                                            }
                                            Toast.hide();
                                        }
                                    })
                                    .catch(error => {
                                        Toast.hide();
                                        Toast.fail("Please re-try again.", 5000, () => { })
                                        console.log(JSON.stringify(error));
                                    });

                            } else {
                                Toast.hide();
                                window.alert("Please ensure excel cells in the productivity template are filled in and with specified format.");
                                event.target.value = null;
                                return false;
                            }

                            
                            

                            
                        }
                    }
                    reader.onerror = (error) => {
                        console.error('Error reading file:', error);
                    };
                } else {
                    return false
                }
            }
        } else {
            Toast.fail("Only project owner, Blackbelt of this project can upload the template file.", 10000, () => { })
            return false;
        }
    }




    FTETemplateUpload = (event, prodBIFTEImpact, prodBiSrNo) => {

        let confirmationMessage = '';
        let filteredData = null;

        filteredData = this.state.gridData && this.state.gridData[prodBiSrNo]
        if (filteredData && filteredData.length > 0) {
            confirmationMessage = "Heads up: Uploading this file will replace any previous data for this ID. If a release isn't in the new file, it will be removed and can't be restored later";
        } else {
            confirmationMessage = "Are you sure you want to upload this excel template ?"
        }

        let userOhr = this.sessionData ? this.sessionData.profile ? this.sessionData.profile.oHRId : "" : "";
        if (parseInt(this.state.OwnerOHR) === parseInt(userOhr) || parseInt(this.state.BlackBeltUserId) === parseInt(userOhr)) {
            var file = event.target.files[0];
            var currFilename = file ? file.name : "";
            var validExtensions = ['.xlsx'];
            var currFileExtension = currFilename.substring(currFilename.lastIndexOf("."));
            var isFileTypeValid = validExtensions.filter((val) => val.toLowerCase().includes(currFileExtension.toLowerCase()));
            if (isFileTypeValid.length <= 0) {
                alert("Only excel file is allowed to Upload.");
                return;
            } else {
                if (window.confirm(confirmationMessage)) {
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(event.target.files[0]);
                    reader.onload = (e) => {
                        console.log("e =>", e)
                        const data = e.target.result;
                        const workbook = XLSX.read(data, { type: 'binary', sheetStubs: true });
                        const sheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[sheetName];

                        const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
                        const hasHeadCountColumn = headers && headers.includes("Headcount Release Levers");

                        if (!hasHeadCountColumn) {
                            Toast.fail("Column 'Headcount Release Levers' is missing. Make sure that the column is present.", 4000);
                            event.target.value = null;
                            return false;
                        }

                        // Set raw: false to get formatted values
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false });
                        const lengthOfRows = jsonData.length;

                        if (lengthOfRows === 0) {
                            Toast.fail("Please insert the records and upload.", 4000, () => { })
                            event.preventDefault()
                            event.target.value = null;
                            return false;
                        }
                        if (lengthOfRows + parseInt(1) > 201) {
                            Toast.fail("Data uploaded in excel is more than 200 rows.", 8000, () => { })
                            event.preventDefault()
                            event.target.value = null;
                            return false;
                        }
                        else {
                            let isValid = true;                                                                                                                                                  
                            const processedData = jsonData && jsonData;
                            
                            if(processedData){
                                const invalidRows = processedData.filter((row, index) => {
                                    const dateVal = row['Realization Date'];
                                    console.log('date value =>',dateVal)
                                    // Accept yyyy-mm-dd or yyyy/mm/dd, then normalize
                                    if (typeof dateVal === 'string' && /^\d{4}[-\/]\d{2}[-\/]\d{2}$/.test(dateVal)) {
                                        const normalizedDate = dateVal.replace(/\//g, '-');
                                        // Optional: validate if it's a real date
                                        const dateObj = new Date(normalizedDate);
                                        return isNaN(dateObj.getTime()); // Invalid date object
                                    }
                                    return true; // Invalid format
                                });
                                if (invalidRows.length > 0) {
                                    //window.alert(`Invalid release date format in ${invalidRows.length} rows. Expected release date format is - 'yyyy-mm-dd'`);
                                    isValid = false;
                                }
                            }
                            console.log('processed data =>', processedData)
                            if (isValid) {
                                Toast.loading("validating data please wait...", () => { });
                                let param = {
                                    case: "new",
                                    casetype: "ValidateFTE",
                                    excelParsedData: processedData,
                                    Account: this.state.AccountManual,
                                    BISrNo: this.state.prodBiSrNo,
                                    ProjectID: this.state.isItIdeaOrGB === "Lean" ? this.props.location.state[1] : this.state.isItIdeaOrGB === "GB" ? this.props.location.state[0] : "",
                                    Region: this.state.RegionManual,
                                    IdeaId: this.state.IdeaId ? this.state.IdeaId : "",
                                    CreateBy: this.sessionData ? this.sessionData.profile ? this.sessionData.profile.oHRId : "" : "",
                                    FTEImpactValue:this.state.prodBIFTEImpact.toString()
                                }
                                console.log("param =>", param)
                                const requestOptions = {
                                    method: 'PUT',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        "Authorization": "Bearer " + this.accessToken,
                                    },
                                    body: JSON.stringify(param)
                                };
                                fetch(`${PRODUCTIVITY_PROJECTS_UPDATE_URL}`, requestOptions)
                                .then(response => response.json())
                                .then(data => {
                                    console.log("excel response =>", data)
                                    event.preventDefault()
                                    if (data) {
                                        event.target.value = null;
                                        const localData = data.ResultSets.Table1;
                                        this.setProductivityDetails(localData);

                                        let PastCount = data.ResultSets.Table2[0].PastCount;
                                        let FTESum = data.ResultSets.Table2[0].FTESum;

                                        if (data.ResultSets.Table2[0].RecStatus === "Success") {
                                            this.setState(prevState => ({
                                                businessImpactValueArray: prevState.businessImpactValueArray.map(item =>
                                                    item.SrNo === this.state.prodBiSrNo
                                                        ? { ...item, OHRPastCount: PastCount,OHRSumFTE:FTESum }
                                                        : item
                                                ),
                                                dataForUploadedScreen: {
                                                    ...prevState.dataForUploadedScreen,
                                                    [this.state.prodBiSrNo]: { OHRPastCount: PastCount, OHRSumFTE:FTESum }
                                                }
                                            }));
                                            this.FTEProjectBIUpdate(this.state.businessImpactValueArray, this.state.prodBiSrNo)
                                        }
                                        if (data.ResultSets.Table2[0].RecStatus === "Error") {

                                            this.setState(prevState => ({
                                                dataForUploadedScreen: {
                                                    ...prevState.dataForUploadedScreen,
                                                    [this.state.prodBiSrNo]: { OHRPastCount: 0, OHRSumFTE:0 }
                                                }
                                            }));

                                            let failureMessage = 'OHR details do not match the current OFCON report. \n Please review and re-upload the file.';
                                            Toast.info(failureMessage, 10000, () => {
                                                window.alert("Data not recorded.")
                                            });
                                        }
                                        Toast.hide();
                                    }
                                })
                                .catch(error => {
                                    Toast.hide();
                                    Toast.fail("Please re-try again.", 5000, () => { })
                                    console.log(JSON.stringify(error));
                                });
                            }else {
                                Toast.hide();
                                window.alert("Please ensure excel cells in the productivity template are filled in and with specified format.");
                                event.target.value = null;
                                return false;
                            }
                        }
                    }
                    reader.onerror = (error) => {
                        console.error('Error reading file:', error);
                    };
                } else {
                    return false
                }
            }
        } else {
            Toast.fail("Only project owner, Blackbelt of this project can upload the template file.", 10000, () => { })
            return false;
        }
    }



    setProductivityUploadDisability = () => {
        const userOhr = this.sessionData?.profile?.oHRId ?? "";
        const { OwnerOHR, BlackBeltUserId, ApprovalStatus, ProjectPhase, ProjectState, WorkType } = this.state;

        const isOwner = parseInt(OwnerOHR) === parseInt(userOhr);
        const isBlackBelt = parseInt(BlackBeltUserId) === parseInt(userOhr);

        // ---- Owner logic ----
        if (isOwner) {

            // For GB Projects
            if((WorkType === 'GB ProDG' && ProjectPhase == 'Deploy') || (WorkType === 'GB BPMS Live' && ProjectPhase === 'Closure')){
                if(ProjectState === 'Active'){
                    return false
                }
            }
            
            // GB + projects
            if((WorkType === 'POV Deploy' && ProjectPhase === 'Deploy')  || (WorkType === 'ProDG 4D' && ProjectPhase === 'Deploy') || (WorkType === 'BPMS Live' && ProjectPhase === 'Closure') || (WorkType === 'Ops Initiatives' && ProjectPhase === 'Initiatives')){
                if(ProjectState !== 'Complete'){
                    return false;
                }
            }

            // for lean projects
            if(ApprovalStatus === PENDING_DOCUMENTS){
                return false;
            }
            return true;
        }

        // ---- Black Belt logic ----
        if (isBlackBelt) {
            const isValidBBStatus = [PENDING_DOCUMENTS, DOCUMENTS_UPLOADED,AWAITING_MASTER_BLACKBELT_APPROVAL,"Awaiting DBSPOC Approval",AWAITING_QAULITY_CHECK_REVIEW].includes(ApprovalStatus) || ["Awaiting Mentor Approval", "Active","Awaiting Certifying Authority Approval","Awaiting DB SPOC Approval",AWAITING_QAULITY_CHECK_REVIEW,AWAITING_MASTER_BLACKBELT_APPROVAL,"Pending Corporate Panel Slot Booking","Awaiting Corporate Panel Approval","Awaiting Champion Approval","Awaiting Champion Approval for Cancellation"].includes(ProjectState);

            if (this.state.WorkType && this.state.WorkType === "Ops Initiatives") {
                if (ProjectPhase && ProjectPhase === "Initiatives") {
                    if (ProjectState && (ProjectState === AWAITING_MASTER_BLACKBELT_APPROVAL || ProjectState === AWAITING_QAULITY_CHECK_REVIEW || ProjectState === "Awaiting Certifying Authority Approval","Pending Corporate Panel Slot Booking","Awaiting Corporate Panel Approval")) {
                        return false;
                    }
                }
            }

            if (!isValidBBStatus) return true;
            return false; // enabled
        }
        return true;
    };


    formatDateString = (dateparam) => {
        return dateparam.toLocaleDateString("en-CA", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    }

    DisplayValidatedOHR = (ID) => {
        if(this.checkIsFteEquivalentPresent(ID)){
            const label = this.state.dataForUploadedScreen?.[ID];
            return <span>{label ? label.OHRPastCount : 0}</span>;
        }else{
            const label = this.state.dataForUploadedScreen?.[ID];
            return <span>{label ? label.OHRValidCount : 0}</span>;
        }
        
    }

    DisplayConsolidatedFTEs = (ID) => {
        const label = this.state.dataForUploadedScreen?.[ID];
        return <span>{label ? label.OHRSumFTE : 0}</span>;
    }
    DisplayPlannedOHR = (ID) => {
        const label = this.state.dataForUploadedScreen?.[ID];
        return <span>{label ? label.OHRFutureCount : 0}</span>;
    }
    DisplayExceptionalOHR = (ID) => {
        const label = this.state.dataForUploadedScreen?.[ID];
        return <span>{label ? label.OHRExceptionCount : 0}</span>;
    }


    checkIsFteEquivalentPresent = (SrNo) => {
        let myBIMasterList = this.state.businessImpactMasterList;
        for (const pg_item of myBIMasterList) {
            if (SrNo === pg_item.pg_srno) {
                if (pg_item.pg_isohruploaded === "FTE") {
                    return true;
                }
            }
        }
        return false;
    }


    render() {
        let filteredData = [];
        let sortedData = [];

        if (this.state.prodBiSrNo && this.state.gridData[this.state.prodBiSrNo]) {
            filteredData = this.state.gridData[this.state.prodBiSrNo];
            sortedData = filteredData.slice().sort((a, b) => a.SOrd - b.SOrd);
        }
        return (
            <section className="u-clearfix u-section-1" id="sec-0f7f">
                <div className="u-clearfix u-sheet u-sheet-1" style={{ marginBottom: 20 }}>
                    <div className="u-align-left u-border-3 u-border-white u-container-style u-expanded-width u-group u-radius-10 u-shape-round u-white u-group-1">
                        <div className="u-container-layout u-container-layout-1">
                            <h4 style={{ textAlign: 'center', color: '#00AECF', fontFamily: 'Arial', fontSize: 22 }}>Upload Productivity OHR: {this.state.isItIdeaOrGB === "Lean" ? this.props.location.state[3] : this.state.isItIdeaOrGB === "GB" ? this.props.location.state[0] : ""} </h4>

                            <div className="u-align-left u-container-style u-expanded-width u-group u-shape-rectangle u-group-2">
                                <div className="u-container-layout u-container-layout-2" style={{ textAlign: 'center' }}>

                                    <div className="">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round">
                                                    <div className="u-container-layout u-container-layout-3">
                                                        <p className="u-align-left u-text u-text-2" style={{ marginBottom: 15 }}>Stakeholder Details</p>
                                                        <div className="row d_flex_align_items_center">
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Owner OHR</label> </div>
                                                            <div className="col-md-6"><input className="form-input" disabled type="text" value={this.state.OwnerOHR} placeholder='Owner OHR' /></div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />
                                                        <div className="row d_flex_align_items_center">
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Owner Name</label> </div>
                                                            <div className="col-md-6"><input className="form-input" disabled type="text" value={this.state.OwnerName} placeholder='Owner Name' /></div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />
                                                        <div className="row d_flex_align_items_center">
                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Mentor&nbsp;Name</label></div>
                                                            <div className="col-md-6">
                                                                <input className="form-input" disabled list="blackbelt" name="blackbelt" placeholder="Blackbelt" title={"OHR ID: " + this.state.BlackBeltUserId} value={this.state.BlackBeltUserName} />
                                                            </div>
                                                            <div className="">
                                                                <div className="campaign_modal_bulb campaign_tool_tip">
                                                                    <img
                                                                        src={require("../assets/images/question_mark_2.png")}
                                                                        alt=""
                                                                        className=""
                                                                    />
                                                                    <span className="my_tooltiptext">For BB projects, MBB will be the mentor.</span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />
                                                        {
                                                            this.state.MBBName && (
                                                                <>
                                                                    <div className="row d_flex_align_items_center">
                                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>MBB</label></div>
                                                                        <div className="col-md-6">
                                                                            <input className="form-input" disabled name="blackbelt" placeholder="MBB" title={"OHR ID: " + this.state.MBBOHR} value={this.state.MBBName} />
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ marginBottom: 15 }} />
                                                                </>)
                                                        }


                                                        <div className="row d_flex_align_items_center">
                                                            <div className="col-md-5">
                                                                <label style={{ verticalAlign: 'bottom' }}>LDT Lead Name</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <input className="form-input" disabled list="ldtName" name="ldtName" value={this.state.LDTLeadName} placeholder="LDT Lead" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <div className="u-border-1 u-border-palette-5-base u-container-style u-radius-6 u-shape-round" style={{ paddingTop: '11px' }}>
                                                    <div className="" >
                                                        <p className="u-align-left u-text u-text-8" >Account Details</p>
                                                        <div className="row" style={{ marginTop: "13px" }}>
                                                            <div className="col-md-6">
                                                                <div className="u-container-style u-group u-shape-rectangle">
                                                                    <div className="u-container-layout ">
                                                                        <div className="row d_flex_align_items_center">
                                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Account&nbsp;Name</label></div>
                                                                            <div className="col-md-7">
                                                                                <input className="form-input" disabled list="accounts" name="accounts" placeholder="Account" value={this.state.AccountManual} />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />
                                                                        <div className="row d_flex_align_items_center">
                                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Holding&nbsp;Account</label></div>
                                                                            <div className="col-md-7">
                                                                                <input className="form-input" disabled type="text" value={this.state.HoldingAccount} placeholder='Holding Account' />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />
                                                                        <div className="row d_flex_align_items_center">
                                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Vertical</label></div>
                                                                            <div className="col-md-7">
                                                                                <input className="form-input" disabled list="vertical" name="vertical" placeholder="Vertical" value={this.state.VerticalManual} />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />
                                                                        <div className="row d_flex_align_items_center">
                                                                            <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Industry&nbsp;Vertical</label></div>
                                                                            <div className="col-md-7">
                                                                                <input className="form-input" disabled list="subverticallist" name="subverticallist" placeholder="Industry&nbsp;Vertical" value={this.state.SubVerticalName} />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />

                                                                        {/* units and segments starts here */}
                                                                        <div className="row d_flex_align_items_center">
                                                                            <div className="col-md-5">
                                                                                <label className="form-attribute" style={{ verticalAlign: 'bottom' }}>Segment</label>
                                                                            </div>
                                                                            <div className="col-md-7">
                                                                                <input placeholder="Segment" className="form-input" disabled name="segment" value={this.state.Segment} style={{ fontWeight: 'normal !important' }} />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />
                                                                        <div className="row d_flex_align_items_center">
                                                                            <div className="col-md-5">
                                                                                <label className="form-attribute" style={{ verticalAlign: 'bottom' }}>Unit</label>
                                                                            </div>
                                                                            <div className="col-md-7">
                                                                                <input placeholder="Unit" className="form-input" disabled name="unit" value={this.state.Unit} style={{ fontWeight: 'normal !important' }} />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />
                                                                        {/* units and segments ends here */}



                                                                        {
                                                                            this.state.CampaignName && (
                                                                                <>
                                                                                    <div className="row d_flex_align_items_center">
                                                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Campaign Name</label></div>
                                                                                        <div className="col-md-7">
                                                                                            <input className="form-input" disabled list="ideationtype" name="ideationtype" placeholder="Campaign Type" value={this.state.CampaignName} />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div style={{ marginBottom: 15 }} />
                                                                                </>
                                                                            )
                                                                        }




                                                                        {
                                                                            this.state.CampaignName === "Gen AI"
                                                                                ?
                                                                                <>
                                                                                    <div className="row">
                                                                                        <div className="col-md-5">
                                                                                            <label style={{ verticalAlign: 'bottom' }}>Gen AI Hackathon Theme</label></div>
                                                                                        <div className="col-md-7">
                                                                                            <input className="form-input" disabled list="subcampaign" name="subcampaign" placeholder="Gen AI Theme" value={this.state.SubCampaignName} />
                                                                                        </div>
                                                                                    </div>

                                                                                </>
                                                                                :
                                                                                null
                                                                        }

                                                                        {
                                                                            this.state.dataBridgeCampaign && (
                                                                                <>
                                                                                    <div className="row">
                                                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Data Bridge Project Theme</label></div>
                                                                                        <div className="col-md-7">
                                                                                            <input className="form-input" disabled list="databridgetype" name="databridgetype" placeholder="Data Bridge Project Type" value={this.state.DataBridgeTheme} />
                                                                                        </div>
                                                                                    </div>

                                                                                </>
                                                                            )
                                                                        }
                                                                        {
                                                                            this.state.xPollinationCampaign && (
                                                                                <>
                                                                                    <div className="row">
                                                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Sub Campaign</label></div>
                                                                                        <div className="col-md-7">
                                                                                            <input className="form-input" disabled list="subcampaign" name="subcampaign" placeholder="Sub Campaign" value={this.state.SubCampaignName} />
                                                                                        </div>
                                                                                    </div>

                                                                                </>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="u-container-layout u-container-layout-6">
                                                                    <div className="row d_flex_align_items_center">
                                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Country</label></div>
                                                                        <div className="col-md-7">
                                                                            <input className="form-input" disabled list="country" name="country" placeholder="Country" value={this.state.Country} />
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ marginBottom: 15 }} />
                                                                    <div className="row d_flex_align_items_center">
                                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Region</label></div>
                                                                        <div className="col-md-7">
                                                                            <input className="form-input" disabled list="regions" name="regions" placeholder="Region" value={this.state.RegionManual} />
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ marginBottom: 15 }} />
                                                                    <div className="row d_flex_align_items_center">
                                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Sub-Region</label></div>
                                                                        <div className="col-md-7">
                                                                            <input className="form-input" disabled list="subregions" name="subregions" placeholder="Sub Region" value={this.state.SubRegion} />
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ marginBottom: 15 }} />
                                                                    <div className="row d_flex_align_items_center">
                                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Service Line</label> </div>
                                                                        <div className="col-md-7"><input className="form-input" disabled type="text" value={this.state.ServiceLineName} placeholder="Eg: Retail Banking, Commercial Lending, Collections" title={this.state.ServiceLineName} /></div>
                                                                    </div>
                                                                    <div style={{ marginBottom: 15 }} />
                                                                    <div className="row d_flex_align_items_center">
                                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom' }}>Sub Service Line</label> </div>
                                                                        <div className="col-md-7">
                                                                            <input className="form-input" disabled name="serviceline" placeholder="Sub Service Line" value={this.state.SubServiceLine} title={this.state.SubServiceLine} />
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ marginBottom: 15 }} />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div className="">
                                            <div className="">
                                                <div className="" style={{ padding: "40px 30px 0px 0px", borderTop: "1px solid lightgrey", marginTop: "30px" }}>
                                                    <p className="u-align-left u-text u-text-2" style={{ marginBottom: 15 }}>Project Details</p>
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="">
                                                                <div className="" style={{ textAlign: "left" }} >
                                                                    <label>Certification Level</label> </div>
                                                                <div className="">
                                                                    <input className="form-input" disabled list="certificationLevel" value={this.state.Certificate} name="certificationLevel" placeholder="Certification Level" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="">
                                                                <div className="" style={{ textAlign: "left" }}>
                                                                    <label>Transformation Lever</label>
                                                                </div>
                                                                <div className="">
                                                                    <input className="form-input" disabled value={this.state.TransformationLever} list="transformationLever" name="transformationLever" placeholder="Transformation Lever Level" />
                                                                </div>
                                                            </div>

                                                            {
                                                                this.state.DigitalProjectType
                                                                    ?
                                                                    <>
                                                                        <div style={{ marginBottom: 15 }} />
                                                                        <div className="">
                                                                            <div className="" style={{ textAlign: "left" }}>
                                                                                <label>Digital Project Type</label>
                                                                            </div>
                                                                            <div className="">
                                                                                <input className="form-input" disabled value={this.state.DigitalProjectType} title={this.state.DigitalProjectType} list="transformationLever" name="transformationLever" placeholder="Transformation Lever Level" />
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    null
                                                            }

                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="">
                                                                <div className="" style={{ textAlign: "left" }}>
                                                                    <label>AI Classification</label>
                                                                </div>
                                                                <div className="">
                                                                    <input className="form-input" disabled value={this.state.AIClassification} placeholder="AI Classification" />
                                                                </div>
                                                            </div>
                                                            {
                                                                this.state.WorkType
                                                                    ?
                                                                    <>
                                                                        <div className="" style={{ marginTop: 15 }}>
                                                                            <div className="" style={{ textAlign: "left" }}>
                                                                                <label>Work Type</label>
                                                                            </div>
                                                                            <div className="">
                                                                                <input className="form-input" disabled list="certificationWorkType"
                                                                                    value={this.state.WorkType} name="certificationWorkType" />
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="">
                                                                <div className="" style={{ textAlign: "left" }}>
                                                                    <label>Tools / Methodology Used</label>
                                                                </div>
                                                                <div className="">
                                                                    <textarea
                                                                        className="form-input"
                                                                        disabled
                                                                        value={this.state.ToolsMethodologies}
                                                                        title={this.state.ToolsMethodologies}
                                                                        list="methodology"
                                                                        name="methodology"
                                                                        placeholder="Tools / Methodology"
                                                                        style={{ width: "100%", overflowY: "scroll", resize: "none" }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {
                                                                this.state.OtherTools
                                                                    ?
                                                                    <>
                                                                        <div className="">
                                                                            <div className="text-left">
                                                                                <span className="form-attribute">Other tools</span>
                                                                            </div>
                                                                            <div className="">
                                                                                <textarea
                                                                                    title={this.state.OtherTools}
                                                                                    className="form-input"
                                                                                    disabled
                                                                                    placeholder="Other tools value"
                                                                                    name="othertools"
                                                                                    value={this.state.OtherTools}
                                                                                    style={{ width: "100%", overflowY: "scroll", resize: "none" }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>


                                                    <div style={{ marginBottom: 50 }} />

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="" style={{ marginTop: "30px", borderTop: '1px solid lightgrey' }}>
                                        <div className="BI_component ">
                                            {
                                                this.state.VDType
                                                    ?
                                                    <>
                                                        <div className="row" style={{ borderBottom: '1px solid lightgrey' }}>
                                                            <div className="col-md-3" >
                                                                <div className="select_impact_type" style={{ paddingTop: "10px" }}>
                                                                    <p className="u-align-left u-text u-text-2" style={{ margin: "10px 0px 11px 0px" }}>Impact Type</p>
                                                                    <div className="">
                                                                        <div className=" text-left">
                                                                            <label className="form-attribute">
                                                                                Value delivery
                                                                            </label>
                                                                        </div>
                                                                        <div className=" text-left">
                                                                            <input disabled value={this.state.VDType} className="form-input disabled_input" placeholder="Value delivery of this project" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-2"></div>
                                                            <div className="col-md-7">
                                                                <div className="final_additional_block" style={{ marginTop: "0px", border: "0px", marginBottom: "0px" }}>
                                                                    <h3 className="idea_form_header" style={{ margin: "15px 0px" }}>Business impact details</h3>
                                                                    <div className="">
                                                                        <div className="">
                                                                            <div className="row">
                                                                                <div className="col-md-4">
                                                                                    <div className="final_additional_block_field">
                                                                                        <div className="">
                                                                                            <div className="text-left">
                                                                                                <label className="form-attribute">Final Impact (# of FTE)</label>
                                                                                            </div>
                                                                                            <div className="">
                                                                                                <input className="form-input" disabled name="finalimpactFTE" value={this.state.VDType === NO_VD ? 0 : this.state.FinalImpactFTE} placeholder="99" />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4">
                                                                                    <div className="final_additional_block_field">
                                                                                        <div className="">
                                                                                            <div className="text-left">
                                                                                                <label className="form-attribute">Final Impact ($)</label>
                                                                                            </div>
                                                                                            <div className="">
                                                                                                <input className="form-input" disabled name="finalimpactdollar" value={this.state.VDType === NO_VD ? 0 : this.state.FinalImpactDollar} placeholder="500" />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4">
                                                                                    <div className="final_additional_block_field">
                                                                                        <div className="">
                                                                                            <div className="text-left">
                                                                                                <label className="form-attribute">Is it a Zero Impact Project</label>
                                                                                            </div>
                                                                                            <div className="text-left" style={{ marginTop: "10px" }}>
                                                                                                {
                                                                                                    this.state.VDType !== NO_VD
                                                                                                        ?
                                                                                                        <>
                                                                                                            <label className="switch">
                                                                                                                <input disabled type="checkbox" checked={false} readOnly />
                                                                                                                <span className="slider round not_allowed_curoser" />
                                                                                                            </label>
                                                                                                        </>
                                                                                                        :
                                                                                                        <label className="switch">
                                                                                                            <input disabled type="checkbox" checked={true} readOnly />
                                                                                                            <span className="slider round not_allowed_curoser" />
                                                                                                        </label>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                            </div>



                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </>
                                                    :
                                                    null
                                            }


                                            {
                                                this.state.businessImpactValueArray && this.state.businessImpactValueArray.length > 0
                                                    ?
                                                    <>
                                                        <div className="VD_form idea_common_block_last_block" style={{ borderBottom: "1px solid lightgrey" }}>
                                                            <div className="">
                                                                <h3 className="idea_form_header">Value Delivery Form</h3>
                                                            </div>
                                                            <div className="bi_summary_latest">
                                                                <div className="row mt-4" style={{ marginLeft: 10, marginRight: 10, justifyContent: "center" }}>
                                                                    <div className="col-md-2 col-xs-12 bi_summary_latest_header_div">
                                                                        <label>Impact Type</label>
                                                                    </div>
                                                                    <div className="col-md-2 col-xs-12 bi_summary_latest_header_div ">
                                                                        <label>Category</label>
                                                                    </div>
                                                                    <div className="col-md-3 col-xs-12 bi_summary_latest_header_div ">
                                                                        <label>Sub Category</label>
                                                                    </div>
                                                                    <div className="col-md-1 col-xs-12 bi_summary_latest_header_div">
                                                                        <label>FTE Impact (#)</label>
                                                                    </div>
                                                                    <div className="col-md-1 col-xs-12 bi_summary_latest_header_div">
                                                                        <label>$ Impact</label>
                                                                    </div>
                                                                    <div className="col-md-1 col-xs-12 bi_summary_latest_header_div">
                                                                        <label>Monetized</label>
                                                                    </div>
                                                                    <div className="col-md-1 col-xs-12 bi_summary_latest_header_div">
                                                                        <label>Validated OHRs</label>
                                                                    </div>
                                                                    <div className="col-md-1 col-xs-12 bi_summary_latest_header_div">
                                                                        <label></label>
                                                                    </div>
                                                                    
                                                                </div>

                                                                {
                                                                    this.state.businessImpactValueArray.map((item, index) => {
                                                                        return (
                                                                            <div key={item.SrNo} className="row" style={{ marginLeft: 10, marginRight: 10, justifyContent: "center" }}>
                                                                                <div className="col-md-2 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                                    <label>{item.ImpactType}</label>
                                                                                </div>
                                                                                <div className="col-md-2 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                                    <label>{item.MonetizableType}</label>
                                                                                </div>
                                                                                <div className="col-md-3 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                                    <label>{item.BISubCategory}</label>
                                                                                </div>
                                                                                <div className="col-md-1 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                                    {
                                                                                        (item.FTEImpact > 0.0)
                                                                                            ?
                                                                                            <>
                                                                                                <input className="form-input" disabled type="number" value={item.FTEImpact} />
                                                                                            </>
                                                                                            :
                                                                                            null
                                                                                    }
                                                                                </div>
                                                                                <div className="col-md-1 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                                    <input className="form-input" type="number" disabled min="0" max="500000000" defaultValue={item.DollarImpact} placeholder={0.0} title={item.DollarImpact} />
                                                                                </div>
                                                                                <div className="col-md-1 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                                    {
                                                                                        item.IsMonetized === "Yes"
                                                                                            ?
                                                                                            <>
                                                                                                <input type="checkbox" checked={true} style={{ cursor: "no-drop" }} readOnly />
                                                                                            </>
                                                                                            :
                                                                                            <input type="checkbox" checked={false} style={{ cursor: "no-drop" }} readOnly />
                                                                                    }
                                                                                </div>
                                                                                <div className="col-md-1 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                                    <div className='productivity_column_label'>
                                                                                        <label style={{ verticalAlign: "bottom" }}>
                                                                                            {
                                                                                                this.checkIsFteEquivalentPresent(item.SrNo) 
                                                                                                ?
                                                                                                <>{item.OHRPastCount ? item.OHRPastCount : ""}</>
                                                                                                :
                                                                                                <>{item.OHRValidCount ? item.OHRValidCount : ""}</>
                                                                                            }
                                                                                            
                                                                                        </label>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-md-1 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                                    {
                                                                                        (item.PValid && item.PValid.length > 0) && (
                                                                                            <div className="productivity_column">
                                                                                                <div className="productivity_column_btn">
                                                                                                    <button onClick={() => this.openProductivityPopUp(index, item)}
                                                                                                        className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2">&nbsp;OHR Upload&nbsp;&nbsp;
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                            }
                                        </div>

                                        {/* ...........productivity pop-up screen starts here............. */}

                                        {
                                            this.state.backFillPopup
                                                ?
                                                <>
                                                    <div className="no_backfill_modal_overlay"></div>
                                                    <div className="productivity_admin_upload_recheck_model no_backfill_popup">
                                                        <div className="modal_body">
                                                            <label>I confirm that no backfill has been hired against these releases.</label>
                                                            <div className="btn_inner_lock">
                                                                <label htmlFor="productivityFileUpload"
                                                                    title="Click to upload template"
                                                                    onClick={(e)=>this.handleUploadProceedClick(e)}
                                                                    className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 productivity_upload_template_label"
                                                                >Proceed</label>
                                                                {/* <input
                                                                    id="productivityFileUpload"
                                                                    type="file"
                                                                    style={{ display: 'none' }}
                                                                    onChange={(event) => this.uploadFile(event, this.state.prodBIFTEImpact, this.state.prodBiSrNo, this.state.prodBiImpact, this.state.prodBiType) }
                                                                    accept=".xlsx"
                                                                /> */}
                                                                <button className="u-active-custom-color-6 u-border-2 u-btn u-btn-round u-radius-6 update_parent_btn" onClick={(e) => this.setState({ backFillPopup: false })}>Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </>
                                                :
                                                null
                                        }


                                        <div className="text-left mt-4">
                                            {
                                                this.state.productivityPopUp
                                                    ?
                                                    <>
                                                        <div className="custom_modal productivity_modal">
                                                            <div className="modal_body productivity_modal_body">
                                                                <div className="row">
                                                                    <div className="col-md-8">
                                                                        <div className="">
                                                                            <h3 className="productivity_pop_up_main_title modal_title">Productivity Validation</h3>
                                                                            <h4 className="productive_title_category">{this.state.prodBiImpact} - {this.state.prodBiType}</h4>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <button type="button" className="close text-right" onClick={(e) => this.closeProductivityPopup(e)}>&times;</button>
                                                                    </div>
                                                                </div>

                                                                <div className="productivity_excel_template_main_block">
                                                                    <div className="">
                                                                        <div className="row">
                                                                            <div className="col-md-5">
                                                                                <div className="">
                                                                                    <div className="excel_template_download">
                                                                                        <div className="">
                                                                                            <div className="excel_template_download_btn_block">
                                                                                                <button title="click to download sample template" onClick={(e) => this.productivitySampleFileDownload(e, this.state.prodBiSrNo)} className='u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6'>Download</button>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="">
                                                                                            <p>Select "download" to download sample excel template</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="">
                                                                                    <div className="" style={{ marginTop: "10px" }}>
                                                                                        <div className="">
                                                                                            <label>{this.checkIsFteEquivalentPresent(this.state.prodBiSrNo) ? "Total FTE Impact from the category above:" : "Total FTE value:"} {isNaN(this.state.prodBIFTEImpact) ? 0 : this.state.prodBIFTEImpact}</label>
                                                                                        </div>
                                                                                        <div className="">
                                                                                            <label>Total validated OHRs uploaded: <span>{this.DisplayValidatedOHR(this.state.prodBiSrNo)}</span> </label>
                                                                                        </div>

                                                                                        {
                                                                                            this.checkIsFteEquivalentPresent(this.state.prodBiSrNo) && (
                                                                                                <div className="">
                                                                                                    <label>Consolidated FTE Impact: <span>{this.DisplayConsolidatedFTEs(this.state.prodBiSrNo)}</span> </label>
                                                                                                </div>
                                                                                            )
                                                                                        }

                                                                                        {
                                                                                            !this.checkIsFteEquivalentPresent(this.state.prodBiSrNo) &&
                                                                                            <>
                                                                                                <div className="">
                                                                                                    <label>Total planned OHRs uploaded: {this.DisplayPlannedOHR(this.state.prodBiSrNo)}</label>
                                                                                                </div>
                                                                                                <div className="">
                                                                                                    <label>Total exceptional OHRs uploaded: {this.DisplayExceptionalOHR(this.state.prodBiSrNo)}</label>
                                                                                                </div>
                                                                                                <div className="">
                                                                                                    <label style={{ verticalAlign: 'bottom', lineHeight: 2 }}>Note: planned OHRs are not validated, please get them validated.</label>
                                                                                                </div>
                                                                                            </>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            

                                                                            <div className="col-md-7">
                                                                                <div className="excel_template_upload">
                                                                                    <div className="">
                                                                                        <div className="excel_template_upload_btn_block">
                                                                                            <div className="">
                                                                                                <button 
                                                                                                    style={{fontSize:"14px"}}
                                                                                                    title="Click to upload template"
                                                                                                    className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6"
                                                                                                    onClick={() => this.setState({backFillPopup:true})}
                                                                                                    disabled={this.setProductivityUploadDisability()}
                                                                                                >Upload template</button>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="excel_upload_notes_block">
                                                                                            <p><u>Note:</u></p>
                                                                                            <div className="">
                                                                                                <p>1. Upload excel file in XLSX format only. Excel file data must not be empty or blank.</p>
                                                                                                <p>2. OHR must be 9-digit number format.</p>
                                                                                                <p>3. Released From PID must be 8 digit in number format.</p>
                                                                                                <p>4. {this.checkIsFteEquivalentPresent(this.state.prodBiSrNo) ? "Realization date" : "Release date"} in <span className="excel_upload_notes_date_format">YYYY-MM-DD</span> format and allowed dates starts from 01-Jan of Current year. Template should not contain more than 200 OHRs.</p>
                                                                                                <p>5. Excel containing only valid records will be saved. Invalid data records will not be saved.</p>
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {
                                                                    this.state.gridData
                                                                        ?
                                                                        <>
                                                                            <div className="">
                                                                                <div className="">
                                                                                    <div className="excel_template_download_btn_block">
                                                                                        <button title="click to export in excel template" onClick={(e) => this.checkIsFteEquivalentPresent(this.state.prodBiSrNo) ? this.FTEExportData(e, this.state.prodBiSrNo) : this.exportProductivityData(e, this.state.prodBiSrNo)} className='u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6' style={{ marginBottom: "10px" }}>Export</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="qc_responsive_comment_log">
                                                                                <div className='productivity_new_table_container'>
                                                                                    {
                                                                                        this.checkIsFteEquivalentPresent(this.state.prodBiSrNo)
                                                                                        ?
                                                                                        sortedData && <ProductivityUIGridFTE data={sortedData} />
                                                                                        :
                                                                                        sortedData && <ProductivityUIGrid data={sortedData} />

                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        null
                                                                }

                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                            }
                                        </div>
                                        {/* ...............productivity pop-up screen ends here................ */}

                                    </div>

                                    <div className="btn-group">
                                        <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={this.cancelEvent}>Done</button>

                                        <input
                                            id="productivityFileUpload"
                                            type="file"
                                            style={{ display: 'none' }}
                                            onChange={(event) => this.checkIsFteEquivalentPresent(this.state.prodBiSrNo) ? this.FTETemplateUpload(event, this.state.prodBIFTEImpact, this.state.prodBiSrNo, this.state.prodBiImpact, this.state.prodBiType) : this.uploadFile(event, this.state.prodBIFTEImpact, this.state.prodBiSrNo, this.state.prodBiImpact, this.state.prodBiType)}
                                            accept=".xlsx"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )

    }
}

export default ProductivityDetailsPage;